import { GitHub } from "@mui/icons-material"
import { Button, LinearProgress, Stack, Typography } from "@mui/material"
import { grey, purple, yellow } from "@mui/material/colors"
import React from "react"

import { MyCard, MyCardTitle } from "./MyCard"
import { Layer } from "./UnderTheHood"

export function LongTermRoadmap() {
  return (
    <MyCard variant="transparent" sx={{ paddingX: 0 }}>
      <Stack gap={3} alignItems="stretch" width="100%" maxWidth={700}>
        <MyCardTitle id="roadmap">Roadmap</MyCardTitle>
        <Layer
          title="1. Digital assets"
          description="Track, analyze and manage your cryptocurrency assets and DeFi positions."
        >
          <Stack
            direction="row"
            gap={1}
            flexWrap="wrap"
            alignItems="center"
            sx={{ color: purple[500] }}
          >
            <LinearProgress
              variant="determinate"
              value={95}
              color="inherit"
              sx={{
                width: 200,
              }}
            />
            <Typography variant="body2">Most functionality live in production.</Typography>
          </Stack>
        </Layer>
        <Layer
          title="2. Stocks, commodities and more"
          description="Manage your stock portfolio, real-estate or anything of value in one place."
        >
          <Stack
            direction="row"
            gap={1}
            flexWrap="wrap"
            alignItems="center"
            sx={{ color: yellow[800] }}
          >
            <LinearProgress
              variant="buffer"
              valueBuffer={90}
              value={66}
              color="inherit"
              sx={{
                width: 200,
              }}
            />
            <Typography variant="body2">
              Stocks & ETFs tracking is live powered by Yahoo Finance.
            </Typography>
          </Stack>
        </Layer>
        <Layer
          title="3. Expenses & budgeting"
          description="Track your expenses, generate forecasts, set budgets and create a complete picture of your finances."
        >
          <Stack
            direction="row"
            gap={1}
            flexWrap="wrap"
            alignItems="center"
            sx={{ color: grey[600] }}
          >
            <LinearProgress
              variant="determinate"
              value={5}
              color="inherit"
              sx={{
                width: 200,
              }}
            />
            <Typography variant="body2">
              Developers needed! Help us build the future of personal finance.
            </Typography>
          </Stack>
        </Layer>
        <Button
          href="https://github.com/orgs/privatefolio/projects/1/"
          target="_blank"
          color="primary"
          size="small"
          startIcon={<GitHub width={14} height={14} />}
          sx={{
            alignSelf: "center",
            background: "rgba(var(--mui-palette-primary-mainChannel) / 0.05)",
            borderRadius: 10,
            "html.dark &": {
              background: "rgba(var(--mui-palette-primary-mainChannel) / 0.15)",
            },
            marginY: -1,
            paddingX: 0.75,
            paddingY: 0.25,
          }}
        >
          See the short-term Roadmap on GitHub
        </Button>
      </Stack>
    </MyCard>
  )
}
